module.exports = "/v2/pages/dashboard/dist/715bdf33ce6d56e088ed82ce52deb035.svg";